

import { zxcvbn } from '@zxcvbn-ts/core';

export default {
  name: "OrkPasswordStrengthMeter",
  emits: ["scoreChange"],
  props: {
    password: {
      type: String,
      required: true
    },
    isScoreCapped: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      segments: 5
    }
  },
  mounted() {
    this.$emit('scoreChange', null);
  },
  computed: {
    strength(): number | null {
      if (!this.password) {
        return null;
      }

      const score = zxcvbn(this.password)?.score;

      if (this.isScoreCapped) {
        return Math.min(Math.max(score, 0), 2);
      }

      return score;
    }
  },
  watch: {
    strength(newVal: number): void {
      this.$emit('scoreChange', newVal);
    }
  }
};
